import { Exchange } from '../enum/Exchange';

export class ExchangeDto {
  exchange: Exchange;
  name: string;
}

